import type { LoadingButtonProps } from '@mui/lab'
import type { BoxProps, ContainerProps, StackProps } from '@mui/material'

class DialogStyle {
  static Container: ContainerProps = {
    maxWidth: false,
    disableGutters: true,
    sx: {
      display: 'flex',
      gap: '1rem',
      flexDirection: 'column'
    }
  }

  static Stack: StackProps = {
    direction: 'column',
    spacing: 2
  }

  static Submit: LoadingButtonProps = {
    sx: {
      alignSelf: 'end'
    }
  }

  static wrapperImage: BoxProps = {
    sx: {
      height: '300px',
      border: '1px solid #eee',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '10px'
    }
  }
}

export default DialogStyle
